import React, { useState, useContext, useEffect } from 'react';
import { LangCtx } from "../../../lib/context";
import {dateFormat} from "../../../lib/functions";
// import DisableDatesSlider from './DisableDatesSlider';
import BtmDeleteSlide from '../../../lib/ui/BtmDeleteSlider';
import ModalAddDays from "./ModalAddDays";
import SlotList from "./SlotList";
import {deleteGroupSchedule} from "../../../actions/schedule";

const ScheduleListItem = (props) => {
    const { l } = useContext(LangCtx);
    // const [openDD, setDD] = useState(false);
    const [openAddDay, setAddDay] = useState(false);
    const [slideD, setSlideD] = useState(false);
    const [existDays, setExistDays] = useState([]);
    const { data } = props;

    useEffect(() => {
        if (props.data) {
            let days = [];
            for(let i = 0; i < props.data.length; i++) {
                let itm = props.data[i];
                days = days.concat(itm.days);
            }
            setExistDays([...days]);
        }
    },[props.data])

    const handleDelete = () => {
        deleteGroupSchedule(data[0].from, data[0].to).then(res => {
            if (res && res.status) {
                props.reloadData();
            } else {
                console.log(res.error);
            }
        }).catch(err => {
            console.log("err === ", err);
        })
    }

    const loadSch = () => {
        setAddDay(prevState => !prevState);
        props.reloadData();
    }

    
    return <div className="shedListGroup">
        {/* {openDD && <DisableDatesSlider open={openDD} handleClose={() => setDD(prevState => !prevState)} data={data[0]} />} */}
        {slideD && <BtmDeleteSlide slideD={slideD} handleCancel={() => setSlideD(prevState => !prevState)} txt={l.conf_del} handleConfirm={handleDelete} />}
        <div className="shedListItem">
            <div className="shedListHdr">
                <div className="hdrItem">
                    <span className="listTxtL">{dateFormat(data[0].from)} - {dateFormat(data[0].to)}</span>
                </div>
                <div className="hdrItem childRight">
                    {/* <button className="btnTxt sm mrgRight8" onClick={() => setDD(prevState => !prevState)}>
                        <img src="/images/icons/no-schedule.png" alt="icon" />
                        <span>{l.disable_date}</span>
                    </button> */}
                    {data && data?.length > 1 && 
                    <button className="btnTxt sm mrgRight8" onClick={() => setSlideD(prevState => !prevState)}>
                        <img src="/images/icons/delete-outline.png" alt="icon" className="invertPrimary"/>
                        <span>{l.delete}</span>
                    </button>
                }
                    {/* <button className="btnTxt sm">
                    <img src="/images/icons/edit-outline.png" alt="icon" />
                        <span>{l.edit}</span>
                    </button> */}
                </div>
            </div>
            <div className="addDaysRow">
                <button className="btnFilled sm ripple" onClick={() => setAddDay(prevState => !prevState)}>
                    <span>{l.add_days}</span>
                </button>
            </div>
            {data.map(item => <SlotList schData={item} key={item.scheduleId} reloadData={() => props.reloadData()} existDays={existDays}/>)}
            
        </div>
        {openAddDay && data && data[0] && <ModalAddDays openAddDay={openAddDay} handleAddDays={() => setAddDay(prevState => !prevState)} existDays={existDays} startDate={data[0].from} endDate={data[0].to} groupId={data[0].groupId} loadSch={loadSch}/>}
    </div>
}

export default React.memo(ScheduleListItem);